// extracted by mini-css-extract-plugin
export default {"root":"J7LC7o","mobile":"V0TPWg"};